"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsManager = void 0;
var EventsManager = /** @class */ (function () {
    function EventsManager() {
        this._eventListeners = {};
        this._wildcardEventListeners = [];
    }
    EventsManager.prototype.on = function (type, handler) {
        if (type === '*') {
            this._wildcardEventListeners.push(handler);
            return;
        }
        (this._eventListeners[type] || (this._eventListeners[type] = [])).push(handler);
    };
    EventsManager.prototype.off = function (type, handler) {
        if (type === '*') {
            this._wildcardEventListeners.splice(this._wildcardEventListeners.indexOf(handler) >>> 0, 1);
            return;
        }
        var eventListeners = this._eventListeners[type];
        if (!eventListeners) {
            return;
        }
        eventListeners.splice(eventListeners.indexOf(handler) >>> 0, 1);
    };
    EventsManager.prototype.emit = function (event) {
        (this._eventListeners[event.type] || []).slice().map(function (handler) {
            handler(event);
        });
        this._wildcardEventListeners.slice().map(function (handler) {
            handler(event);
        });
    };
    return EventsManager;
}());
exports.EventsManager = EventsManager;
//# sourceMappingURL=events-manager.js.map